import {setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {PlayerEnums} from '../../../../../shared/GameEnums'
import {RoomState} from '../../../../../shared/RoomState'
import {socket} from '../../../../shared/scripts/EntryShared'
import {UIRoomCenterSettingsSpeedView} from './UIRoomCenterSettingsSpeedView'

export enum UIRoomCenterSettingSpeedType {
    BotSpeed, GameSpeed
}

export class UIRoomCenterSettingsSpeedController {
    readonly type: UIRoomCenterSettingSpeedType
    private readonly views: UIRoomCenterSettingsSpeedView
    private _currentSetting: keyof typeof PlayerEnums.GameSpeedSettings

    constructor(type: UIRoomCenterSettingSpeedType) {
        this.type = type
        this.views = new UIRoomCenterSettingsSpeedView(this.type)
        this.currentSetting = this.views.speedDefaultSetting
    }

    get currentSetting(): keyof typeof PlayerEnums.GameSpeedSettings {
        return this._currentSetting
    }

    set currentSetting(value: keyof typeof PlayerEnums.GameSpeedSettings) {
        this._currentSetting = value
        setElementInnerHTML(this.views.speedInput, {key: `strings:colonistCommon.SpeedSettings.${this.currentSetting}`})
    }

    update(newRoomState: RoomState) {
        this.updateSpeedSettings(this.views.getSetting(newRoomState, this.type))

        this.views.speedDiv.className = this.views.speedInput.innerHTML == this.views.speedDefaultSetting ?
            'room_option_item deselected' : 'room_option_item selected'
    }

    private updateSpeedSettings(newSetting: keyof typeof PlayerEnums.GameSpeedSettings) {
        const optionsArray = this.views.speedOptions
        const currentIndex = optionsArray.indexOf(this.currentSetting)
        const newIndex = optionsArray.indexOf(newSetting)
        if(currentIndex != newIndex) this.currentSetting = optionsArray[newIndex]
    }

    load(roomState: RoomState) {
        this.initSpeedSettings(roomState)
    }

    private initSpeedSettings(roomState: RoomState) {
        const {
            speedDivBody: footerDiv,
            speedRightArrow: rightArrow,
            speedLeftArrow: leftArrow,
            speedOptions: optionsArray,
            speedSocketCommand: socketCommand,
        } = this.views

        if(UIRoomCenterSettingsSpeedController.isGuest(roomState)) {
            footerDiv.className = 'option_body guest'
            rightArrow.onclick = () => undefined
            leftArrow.onclick = () => undefined
            return
        }
        footerDiv.className = 'option_body'
        rightArrow.onclick = () => {
            const currentIndex = optionsArray.indexOf(this.currentSetting)
            let newIndex = currentIndex - 1
            if(newIndex < 0) newIndex = optionsArray.length - 1
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        }

        leftArrow.onclick = () => {
            const currentIndex = optionsArray.indexOf(this.currentSetting)
            let newIndex = currentIndex + 1
            if(newIndex >= optionsArray.length) newIndex = 0
            this.currentSetting = optionsArray[newIndex]
            socketCommand(this.currentSetting)
        }
    }

    updateInteractabilityOfElements(roomState: RoomState) {
        this.load(roomState)
    }

    private static isGuest(roomState: RoomState): boolean {
        return socket.controller.session.id != roomState.hostSession.userSessionId
    }
}
